import jwt_decode from 'jwt-decode';
import { USER_INFO_STORAGE_KEY } from '@ax/constants';

type JwtUserObjectType = {
  exp: number;
};

export class AuthCreate {
  private STORAGE_KEY_TOKEN = 'wp_user:access_token';
  private STORAGE_KEY_INFO = USER_INFO_STORAGE_KEY;
  private STORAGE_KEY_INSTANCE_ID = 'wp_app:instance_id';

  constructor() {}

  private decodeJwt(token: string) {
    return jwt_decode(token);
  }

  saveUser(token: string) {
    localStorage.setItem(this.STORAGE_KEY_TOKEN, token);
    localStorage.setItem(this.STORAGE_KEY_INFO, JSON.stringify(this.decodeJwt(token)));
  }

  haveToken() {
    const token = localStorage.getItem(this.STORAGE_KEY_TOKEN);
    if (token) {
      return true;
    }
    return false;
  }

  isLoggedIn() {
    const token = this.haveToken();

    if (token) {
      const user: JwtUserObjectType | null = this.currentUser();
      if (user) {
        const userExp = user.exp * 1000;
        const currentTime = Date.now();
        if (userExp < currentTime) {
          return false;
        }
      }
      return true;
    }
    return false;
  }

  getAccessToken() {
    return localStorage.getItem(this.STORAGE_KEY_TOKEN);
  }

  currentUser() {
    const userInfo = localStorage.getItem(this.STORAGE_KEY_INFO);
    return userInfo ? JSON.parse(userInfo) : null;
  }

  logout() {
    localStorage.removeItem(this.STORAGE_KEY_TOKEN);
    localStorage.removeItem(this.STORAGE_KEY_INFO);
    localStorage.removeItem(this.STORAGE_KEY_INSTANCE_ID);
    sessionStorage.clear();
  }
}

export const Auth = new AuthCreate();
